import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  
  return (
    <footer className="app-footer">
      <p className="footer-text">
        {t('footer.madeWithLove')} <span className="footer-heart">♥</span> {t('footer.team')}
      </p>
      <p className="footer-links">
        <a href="mailto:d.obedkin@cyclingvirtualleague.com" className="footer-link">
          {t('footer.feedback')}
        </a>
        <span className="footer-separator">|</span>
        <a href="https://t.me/rouvy_cvl" target="_blank" rel="noopener noreferrer" className="footer-link">
          {t('footer.telegram')}
        </a>
        <span className="footer-separator">|</span>
        <Link to="/terms" className="footer-link">
          {t('footer.terms')}
        </Link>
      </p>
    </footer>
  );
};

export default Footer;